var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25037 17.75C4.84145 17.75 2.60618 16.829 2.01583 16.516C1.70969 16.3537 0.572376 15.6635 0.774206 15.0653C1.02421 14.3262 2.56852 13.9608 3.78581 13.6783C5.50873 13.2765 7.01509 12.7059 7.01509 11.7034C7.01509 10.4919 4.77964 8.52513 4.77964 5.132C4.77964 1.73743 7.60424 0.75 9.25019 0.75C10.8957 0.75 13.7211 1.73746 13.7211 5.132C13.7211 8.5252 11.4856 10.492 11.4856 11.7034C11.4856 12.7062 12.9916 13.2768 14.7149 13.6783C15.9319 13.9608 17.4764 14.3263 17.7265 15.0653C17.9284 15.6637 16.7905 16.3538 16.4848 16.516C15.8948 16.8287 13.6594 17.75 9.25037 17.75Z",
    stroke: "url(#paint0_linear_62_1008)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_1008",
    x1: 17.4462,
    y1: -1.16149,
    x2: -2.2114,
    y2: 17.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.a3ed9a9550c03bf49996dea2229338db.svg";
export { ForwardRef as ReactComponent };